import script from "./GridLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./GridLoader.vue?vue&type=script&setup=true&lang=js"

import "./GridLoader.vue?vue&type=style&index=0&id=fff2d0d6&lang=css"

const __exports__ = script;

export default __exports__